import {
  Tabs,
  Card,
  Heading,
  TextStyle,
  Avatar,
  Button,
  ButtonGroup,
  ActionList,
  DisplayText,
  Checkbox,
  ProgressBar,
  Page,
  Modal,
  Sheet
} from '@superops/ui-design-system';
import {
  Loader,
  EventEmitter,
  DateTimeFormatter,
  B1,
  CurrencyText,
  InlineEdit,
  getTranslatedText,
  DeleteModal,
  TEXT_LENGTH,
  AddProducts,
  useProduct,
  COMMON_CONSTANTS,
  EmojiPicker,
  EmojiRender,
  CustomModal,
  toast,
  generateString,
  DATE_TIME_FORMAT,
  getRunbooksDataProperties,
  AccessControl,
  withErrorBoundary
} from '@nile/components';
import {
  dompurifier,
  EventEmitterWithIndex,
  useActivityTracker
} from '@nile/components/src/Utils/helpers';
import Collapse from 'react-collapse';
import TimerPopup from '@nile/components/src/Containers/NewWorklog/TimerPopup';
import { useQuery, useLazyQuery, useMutation, from } from '@apollo/client';

import {
  MockTicketClient,
  TicketClient,
  UPDATE_RUNBOOK,
  GET_RUNBOOK,
  GET_RUNBOOK_ACTION_AUDIT,
  GET_ALL_TEMPLATELIST,
  EXECUTE_ENTITY_FLOW_ACTION,
  GET_TASK_CONTENT_FROM_TEMPLATE,
  GET_RUNBOOK_APPROVERS,
  GET_DEFAULT_REPLY_TEMPLATE,
  UPDATE_ENTITY_FLOW_ACTION_STATUS,
  GET_RUNBOOK_ACTION_INFO,
  AccountClient
} from '@nile/graphql';
import { GET_TICKET_REPLY_RECIPEINTS } from '@nile/graphql/src/Query/ticket';
import { Tooltip } from 'react-clone-tippy';
// import { useMutation } from '@apollo/client';
import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useRef
} from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import {
  clone,
  cloneDeep,
  isEmpty,
  template,
  update,
  capitalize
} from 'lodash';
import { TABLE_ROW_COUNT } from '@nile/rmm/src/constants';
import NonMonitoredAssetDetails from '@nile/rmm/src/modules/it-documentation/components/pages/non-monitored-asset-details/index';
import TicketApprovalCard from '@nile/mangifera/src/Containers/CardContainers/TicketApproval';
import TaskFromRevamp from '@nile/components/src/Forms/TaskFromRevamp';
import RunScriptsModalContent from './RunScriptsModalContent';
import UpdatePropertyContent from './UpdatePropertyContent';
import ApprovalContent from './ApprovalContent';
import RunScriptsOutput from './RunScriptsOutput';
import dayjs from 'dayjs';
import { GET_KB_ITEM } from '@nile/rmm/src/modules/knowledge-base/graphql';
import ArticleReader from '@nile/rmm/src/modules/knowledge-base/components/ArticleSearchSheet/ArticleReader';

const refreshTicketList = [
  'TASK_TEMPLATE',
  'TICKET_UPDATE',
  'TICKET_APPROVAL',
  'ADD_WORKLOG',
  'INITIATE_APPROVAL'
];

function UnifiedRunbookList(props) {
  const { intl, ticket, isTemplate = false, refreshTicketDetailsPage } = props;
  const [runbookId, setRunbookId] = useState(
    ticket?.sop?.sopId || props?.runbookId
  );
  const context = useContext(TicketContext);

  const [listInfo, setListInfo] = useState({
    page: 1,
    pageSize: TABLE_ROW_COUNT
  });

  const [showKb, setShowKb] = useState({
    isOpen: false,
    articleId: null
  });
  const toggleKBSheetActive = () =>
    setShowKb((prev) => ({ ...prev, isOpen: !prev.isOpen }));

  const timerPopupRef = useRef();

  const [currentRunBookDetails, setCurrentRunBookDetails] = useState(null);
  const [currentRunBookActionAudit, setCurrentRunBookActionAudit] = useState(
    null
  );

  const [sortedNodes, setSortedNodes] = useState([]);

  const [completedListItems, setCompletedListItems] = useState([]);
  const [completedItemsOpen, setCompletedItemsOpen] = useState(false);

  const [triggeredAction, setTriggeredAction] = useState({});

  const { loading, data: alltasksData } = useQuery(GET_ALL_TEMPLATELIST); // calling here since during update page render we dont have this list data.
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  // const [actionValueData, setActionValueData] = useState({});
  const [taskTemplate, setTaskTemplate] = useState({});
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: null,
    actionData: null
  });

  const [autoActionModal, setAutoActionModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [sheetActive, setSheetActive] = useState(false);
  const [
    runScriptsOutputModalActive,
    setRunScriptsOutputModalActive
  ] = useState({
    isOpen: false,
    actionData: null
  });

  const toggleRunScriptsOutputModalActive = () => {
    setRunScriptsOutputModalActive((prev) => ({
      ...prev,
      isOpen: !runScriptsOutputModalActive.isOpen
    }));
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    handleModalClose();
  };

  const [executeEntityFlowActionApi, { loading: executeLoading }] = useMutation(
    EXECUTE_ENTITY_FLOW_ACTION,
    {
      onCompleted(res) {
        if (res) {
          toast('success', 'app.label.triggered');
          setModalOpen(false);
          setSheetActive(false);
          setModalState({
            isOpen: false,
            type: null,
            actionData: null
          });
          setTaskTemplate(null);
          const auditValueType = res?.executeEntityFlowAction?.auditValueType;

          if (auditValueType === 'SCRIPT' || !auditValueType) {
            //!auditValueType = auto actions
            fetchRunbookActionAudit();
          }

          if (auditValueType === 'TICKET_APPROVAL') {
            EventEmitter.dispatch('refetchTicketApproval');
            EventEmitter.dispatch('approvalChange');
          }
          if (refreshTicketList.includes(auditValueType) || !auditValueType) {
            refreshTicketDetailsPage();
            if (auditValueType === 'TASK_TEMPLATE') {
              EventEmitter.dispatch('taskAddition');
            }
          }
        }
      }
    }
  );

  const [updateEntityFlowActionStatusApi] = useMutation(
    UPDATE_ENTITY_FLOW_ACTION_STATUS,
    {
      // client: MockTicketClient,
      client: TicketClient,
      onCompleted(res) {
        if (res?.updateEntityFlowActionStatus?.[0]?.status === 'COMPLETED') {
          useActivityTracker({
            event: 'Marked a step complete'
          });
        }
      },
      onError({ graphQLErrors }) {
        fetchRunbookActionAudit();
      }
    }
  );

  const updateActionOrder = (actions) => {
    const updatedActions = actions.map((action, index) => {
      return {
        ...action,
        actionOrder: index
      };
    });
    return updatedActions;
  };

  function initialSort(actions) {
    const actionMap = new Map();
    const independentActions = [];
    const dependentActions = new Map();
    const orphanedActions = [];

    // Map actions and categorize independent/dependent actions
    actions.forEach((item) => {
      const actionId = item.flowAction.actionId;
      actionMap.set(actionId, item);

      if (item.parentFlowAction && item.parentFlowAction.actionId) {
        const parentId = item.parentFlowAction.actionId;
        if (!dependentActions.has(parentId)) {
          dependentActions.set(parentId, []);
        }
        dependentActions.get(parentId).push(item);
      } else {
        independentActions.push(item);
      }
    });

    // Identify orphaned actions
    actions.forEach((item) => {
      if (
        item.parentFlowAction &&
        item.parentFlowAction.actionId &&
        !actionMap.has(item.parentFlowAction.actionId)
      ) {
        orphanedActions.push(item);
      }
    });

    // Sort independent actions by actionOrder
    independentActions.sort((a, b) => a.actionOrder - b.actionOrder);

    // Sort dependent actions for each parent
    dependentActions.forEach((deps) =>
      deps.sort((a, b) => a.actionOrder - b.actionOrder)
    );

    // Sort orphaned actions by actionOrder
    orphanedActions.sort((a, b) => a.actionOrder - b.actionOrder);

    const sortedList = [];

    function insertWithDependents(action) {
      sortedList.push(action);

      const dependents = dependentActions.get(action.flowAction.actionId);
      if (dependents) {
        dependents.forEach((dependent) => insertWithDependents(dependent));
      }
    }

    // Insert independent actions along with their dependents
    independentActions.forEach((action) => insertWithDependents(action));

    //Insert orphaned actions.
    orphanedActions.forEach((orphan) => insertWithDependents(orphan));

    return sortedList;
  }

  const [fetchRunbook, { loading: runbookLoading }] = useLazyQuery(
    GET_RUNBOOK,
    {
      client: TicketClient,
      skip: !runbookId,
      variables: {
        input: {
          sopId: runbookId
        }
      },
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      onCompleted(res) {
        if (res?.getRunbook) {
          const actions = res?.getRunbook?.actions;
          if (Array.isArray(actions) && actions.length === 0) {
            return;
          }
          const updateNodesLayout = updateActionOrder(initialSort(actions));
          setSortedNodes(updateNodesLayout);
          setCurrentRunBookDetails(res?.getRunbook);
        }
      },
      onError() {}
    }
  );
  const fetchGetRunbookActionInfo = (actionId, cb) => {
    const variables = {
      input: {
        actions: [
          {
            flowAction: {
              actionId: actionId
            }
          }
        ],
        ticket: {
          ticketId: ticket?.ticketId
        }
      }
    };

    TicketClient.query({
      query: GET_RUNBOOK_ACTION_INFO,
      variables: variables,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (cb) {
        cb(res);
      }
    });
  };

  const seperateCompletedAndSortedItems = (actionsList, actionAuditList) => {
    if (Array.isArray(actionsList) && actionsList.length === 0) {
      return {
        completedItems: [],
        sortedNodes: []
      };
    }

    const completedItems = [];
    const sortedNodeItems = [];

    let updatedActionsList = updateActionOrder(initialSort(actionsList));

    updatedActionsList.forEach((action) => {
      const actionAudit = actionAuditList.find(
        (audit) => audit.action.actionId === action.flowAction.actionId
      );

      if (actionAudit && actionAudit.status === 'COMPLETED') {
        completedItems.push(action);
      } else {
        sortedNodeItems.push(action);
      }
    });

    return {
      completedItems: completedItems,
      sortedNodeItems: sortedNodeItems
    };
  };

  const [
    fetchRunbookActionAudit,
    { loading: runbookActionAuditLoading }
    // } = useQuery(GET_RUNBOOK, {
  ] = useLazyQuery(GET_RUNBOOK_ACTION_AUDIT, {
    client: TicketClient,
    // skip: !runbookId,
    variables: {
      input: {
        ticket: {
          ticketId: ticket?.ticketId
        },
        runbook: {
          sopId: runbookId
        }
      }
    },

    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted(res) {
      // setCurrentRunBookDetails(res?.getRunbook);
      if (res?.getRunbookActionAudit) {
        const actions = res?.getRunbookActionAudit?.runbook?.actions;
        const actionAudit = res?.getRunbookActionAudit?.actionAudit;

        if (Array.isArray(actions) && actions.length === 0) {
          return;
        }

        const {
          completedItems,
          sortedNodeItems
        } = seperateCompletedAndSortedItems(actions, actionAudit);

        setSortedNodes(sortedNodeItems);
        setCompletedListItems(completedItems);

        setCurrentRunBookDetails(res?.getRunbookActionAudit?.runbook);
        setCurrentRunBookActionAudit(actionAudit);
      }
    },
    onError() {
      console.log('cm::RunbookActionAudit here');
    }
  });

  function sortFlowActions(actions) {
    const actionMap = new Map();
    const independentActions = [];
    const dependentActions = new Map();
    const orphanedActions = new Set();

    // Map actions and categorize independent/dependent actions
    actions.forEach((item) => {
      const actionId = item.flowAction.actionId;
      actionMap.set(actionId, item);

      if (item.parentFlowAction && item.parentFlowAction.actionId) {
        const parentId = item.parentFlowAction.actionId;
        if (!dependentActions.has(parentId)) {
          dependentActions.set(parentId, []);
        }
        dependentActions.get(parentId).push(item);
      } else {
        independentActions.push(item);
      }
    });

    // Identify orphaned actions
    actions.forEach((item) => {
      if (
        item.parentFlowAction &&
        item.parentFlowAction.actionId &&
        !actionMap.has(item.parentFlowAction.actionId)
      ) {
        orphanedActions.add(item);
      }
    });

    // Sort independent actions by actionOrder
    independentActions.sort((a, b) => a.actionOrder - b.actionOrder);

    // Sort dependent actions for each parent
    dependentActions.forEach((deps) =>
      deps.sort((a, b) => a.actionOrder - b.actionOrder)
    );

    function insertWithDependents(action, sortedList) {
      // Find the correct position based on actionOrder
      let index = sortedList.findIndex(
        (item) => item.actionOrder > action.actionOrder
      );
      if (index === -1) {
        sortedList.push(action);
      } else {
        sortedList.splice(index, 0, action);
      }

      // Insert dependents
      const dependents = dependentActions.get(action.flowAction.actionId);
      if (dependents) {
        dependents.forEach((dependent) =>
          insertWithDependents(dependent, sortedList)
        );
      }
    }

    const sortedList = [];

    // Insert independent actions along with their dependents
    independentActions.forEach((action) =>
      insertWithDependents(action, sortedList)
    );

    // Sort orphaned actions by actionOrder before inserting
    const orphanedArray = Array.from(orphanedActions);
    orphanedArray.sort((a, b) => a.actionOrder - b.actionOrder);

    // Insert orphaned actions based on actionOrder
    orphanedArray.forEach((orphan) => insertWithDependents(orphan, sortedList));

    return sortedList;
  }
  const handleModalClose = useCallback(() => {
    setModalState({
      isOpen: false,
      type: null,
      actionData: null
    });
    setTaskTemplate(null);
  }, []);

  function getDependents(actionId, jsonArray) {
    const dependents = jsonArray.filter(
      (node) =>
        node.parentFlowAction && node.parentFlowAction.actionId === actionId
    );

    if (dependents.length === 0) {
      return [];
    }

    const nestedDependents = dependents.flatMap((node) => [
      node,
      ...getDependents(node.flowAction.actionId, jsonArray)
    ]);

    return nestedDependents;
  }

  const onActionComplete = (val, action) => {
    const request = {
      variables: {
        input: {
          entity: 'TICKET',
          entityId: ticket?.ticketId
          // action: [action]
          // status: 'SUCCESS' || 'PROGRESS'
        }
      }
    };

    if (val) {
      request.variables.input.status = 'COMPLETED';
      request.variables.input.actions = [
        {
          flowAction: {
            actionId: action.flowAction.actionId
          }
        }
      ];
      // Action completed
      setCompletedListItems((prev) => {
        return sortFlowActions([...prev, action]);
      });

      setSortedNodes((prev) => {
        return prev.filter(
          (item) => item.flowAction.actionId !== action.flowAction.actionId
        );
      });
    } else {
      request.variables.input.status = 'PROGRESS';

      const dependents = getDependents(
        action.flowAction.actionId,
        completedListItems
      );

      request.variables.input.actions = cloneDeep([action, ...dependents]).map(
        (action) => ({
          flowAction: { actionId: action.flowAction.actionId }
        })
      );

      setCompletedListItems((prev) => {
        const allToRemove = [action, ...dependents];
        return sortFlowActions(
          prev.filter(
            (item) =>
              !allToRemove.some(
                (toRemove) =>
                  toRemove.flowAction.actionId === item.flowAction.actionId
              )
          )
        );
      });

      setSortedNodes((prev) => {
        return sortFlowActions([...prev, action, ...dependents]);
      });
    }
    updateEntityFlowActionStatusApi(request);
  };

  function checkActionIdInCompletedItems(actionIdToCheck) {
    for (const item of completedListItems) {
      if (item.flowAction && item.flowAction.actionId === actionIdToCheck) {
        return true;
      }
    }
    return false;
  }

  const getSideConversationTemplateContent = (action) => {
    const { actionValueData } = action?.flowAction;
    EventEmitter.dispatch('openTicket.side.conversation', {
      templateId: actionValueData.notificationTemplate.id
    });
  };

  const getReplyTemplateContent = (actionValueData, selectedMailbox) => {
    TicketClient.query({
      query: GET_DEFAULT_REPLY_TEMPLATE,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          ticket: {
            ticketId: ticket.ticketId
          },
          mailbox: {
            boxId: selectedMailbox[0].boxId || null
          },
          template: {
            templateId: actionValueData.notificationTemplate.id
          }
        }
      }
    }).then((res) => {
      console.log('res:', res);
      setModalState({
        isOpen: false,
        type: null,
        actionData: null
      });
      EventEmitterWithIndex.dispatch('insertTicketConversation', {
        content: res?.data?.getConversationContentFromReplyTemplate?.content,
        attachments:
          res?.data?.getConversationContentFromReplyTemplate?.attachments,
        timeout: 500
      });
    });
  };

  async function getTicketReplyTemplate(action) {
    const { actionValueType, actionValueData, actionId } = action?.flowAction;

    try {
      TicketClient.query({
        query: GET_TICKET_REPLY_RECIPEINTS,
        variables: {
          ticketInput: {
            ticketId: ticket.ticketId
          }
        },
        fetchPolicy: 'network-only'
      }).then((res) => {
        if (res) {
          let selectedMailbox =
            res?.data?.getTicketConversationReplyRecipients?.mailboxes;
          console.log('selectedMailbox:', selectedMailbox);
          // setSelectedMailbox(selectedMailbox);
          getReplyTemplateContent(actionValueData, selectedMailbox);
        }
      });
    } catch (error) {
      console.error('Error fetching approvers:', error);
    }
  }

  function getSegmentsBasedOnTimeSpent(timeInMinutes) {
    const segments = [];
    let timespentInMinutes = timeInMinutes;
    const endTime = dayjs(Date.now())
      .set('second', 0)
      .set('millisecond', 0);
    let startTime = dayjs(endTime).subtract(timeInMinutes, 'minutes');

    do {
      if (dayjs(endTime).isSame(startTime, 'date')) {
        segments.push({
          segmentId: `${generateString(5)}`,
          startTime: startTime.format(DATE_TIME_FORMAT),
          endTime: endTime.format(DATE_TIME_FORMAT),
          timespent: startTime
            ? dayjs(endTime).diff(dayjs(startTime)) / (60 * 60 * 1000)
            : '',
          afterHours: false
        });
        timespentInMinutes = null;
        break;
      } else {
        const segmentEndTime = dayjs(startTime).endOf('day');
        const segmentTimeSpent = startTime
          ? dayjs(segmentEndTime).diff(dayjs(startTime)) / (60 * 60 * 1000)
          : '';
        segments.push({
          segmentId: `${generateString(5)}`,
          startTime: startTime.format(DATE_TIME_FORMAT),
          endTime: segmentEndTime.format(DATE_TIME_FORMAT),
          timespent: segmentTimeSpent,
          afterHours: false
        });
        startTime = dayjs(segmentEndTime)
          .add(1, 'minutes')
          .set('second', 0)
          .set('millisecond', 0);
        timespentInMinutes = timespentInMinutes - segmentTimeSpent;
      }
    } while (!!timespentInMinutes);

    return segments;
  }

  const onActionTrigger = (action) => {
    let {
      actionValueType,
      actionId,
      actionType,
      actionValueData
    } = action?.flowAction;
    if (actionType === 'GROUP') {
      actionValueType = 'GROUP';
    }
    setTriggeredAction(action);

    useActivityTracker({
      event: 'Triggered an action',
      data: {
        source: actionValueType
      }
    });

    switch (actionValueType) {
      case 'TASK_TEMPLATE':
        const taskTemplateId =
          action?.flowAction.actionValueData.taskTemplate.taskTemplateId;

        setModalState({
          isOpen: true,
          type: actionValueType,
          actionData: action
        });

        TicketClient.query({
          query: GET_TASK_CONTENT_FROM_TEMPLATE,
          variables: { input: [{ taskTemplateId: taskTemplateId }] },
          fetchPolicy: 'network-only'
        }).then((res) => {
          setTaskTemplate(res?.data?.getTaskContentFromTemplate[0]);
        });
        break;
      case 'TICKET_APPROVAL':
        // getApproversList(action);
        setSheetActive(true);
        break;

      case 'KNOWLEDGE_BASE':
        const articleId =
          action?.flowAction?.actionValueData?.kbArticle?.itemId;
        setShowKb({
          isOpen: true,
          articleId: articleId
        });
        break;
      case 'TICKET_REPLY':
        setModalState({
          isOpen: true,
          type: actionValueType,
          actionData: action
        });
        getTicketReplyTemplate(action);
        break;

      case 'SIDE_CONVERSATION':
        getSideConversationTemplateContent(action);
        break;

      // setTaskTemplate(res?.data?.getTaskContentFromTemplate[0]);

      case 'TICKET_UPDATE':
        setModalState({
          isOpen: true,
          type: actionValueType,
          actionData: {
            ...action
          }
        });
        //call ticket update api.
        break;

      case 'NON_MONITORING_ASSET':
        toggleModal();
        break;

      case 'SCRIPT':
        toggleModal();
        break;

      case 'REQUEST_NOTE':
        EventEmitterWithIndex.dispatch('insertNote', {
          content: ''
        });
        break;
      case 'GROUP':
        toggleModal();
        setModalState({
          isOpen: true,
          type: actionValueType,
          actionData: action
        });
        break;

      case 'WORKLOG':
        const popoverData = {
          currentTimer: {
            segments: getSegmentsBasedOnTimeSpent(
              actionValueData.worklog.timeSpent * 60
            ),
            notes: actionValueData.worklog.notes,
            billable: actionValueData.worklog.billable,

            disableSaveTimer: true
          },
          onlyManual: true,
          aiWorklogNotes: false,
          timerNote: ''
        };
        if (props?.ticket) {
          popoverData.currentTimer.workItem = {
            ...props?.ticket,
            module: 'TICKET',
            workId: props?.ticket?.ticketId
          };
        }

        if (isMSPProduct) {
          popoverData.currentTimer.serviceItem =
            actionValueData?.worklog?.serviceItem;
          popoverData.currentTimer.serviceCatalogItem =
            actionValueData?.worklog?.serviceItem;
        }

        if (timerPopupRef?.current?.togglePopover) {
          timerPopupRef.current.togglePopover(popoverData);
          // trackEvent('Added manual time from reply editor');
        }

        break;

      default:
        break;
    }
  };

  const getFlowActionStatus = (actionId, isGroupAutoAction = false) => {
    const actionAudit = currentRunBookActionAudit?.filter(
      (audit) => audit.action.actionId === actionId
    );

    // const currentRunbookAction = currentRunBookDetails?.actions?.filter(
    //   (action) => action.flowAction.actionId === actionId
    // );

    // let actionValueData = null;

    // if (!isEmpty(currentRunbookAction) && currentRunbookAction[0]?.flowAction) {
    //   actionValueData = currentRunbookAction[0].flowAction;
    // }

    if (!actionAudit || actionAudit?.length === 0) {
      return null;
    }

    const { auditValueData, auditValueType, status } = actionAudit[0];
    if (auditValueType === 'SCRIPT') {
      const cb = (res) => {
        setRunScriptsOutputModalActive({
          isOpen: true,
          scripts: res?.data?.getRunbookActionInfo?.[0]?.auditValueData?.scripts
        });
      };

      if (!auditValueData?.scripts) {
        return null;
      }

      return (
        <span>
          {' '}
          Applied on{' '}
          <Button
            onClick={() => {
              setRunScriptsOutputModalActive({
                isOpen: true
              });
              fetchGetRunbookActionInfo(actionId, cb);
            }}
            plain
          >
            {auditValueData?.scripts?.length} Assets{' '}
          </Button>{' '}
        </span>
      );
    }
    if (isGroupAutoAction && status === 'FAILURE') {
      const error = JSON.parse(auditValueData?.error);
      const errorMessage = error?.errorCode
        ? getTranslatedText(intl, `app.errorCode.${error?.errorCode}`)
        : error?.message;
      return (
        <div className="flex">
          <span className="mr-10">
            <TextStyle variation="negative">{errorMessage}</TextStyle>
          </span>
          <span
            onClick={() => {
              executeEntityFlowAction(actionId);
            }}
          >
            <SVGIcon name="RotateRefreshLoading" />
          </span>
        </div>
      );
    }
    if (auditValueType === 'TASK_TEMPLATE') {
      return (
        <TextStyle variation="subdued" weight="Regular">
          <span>{auditValueData?.task?.status}</span>
        </TextStyle>
      );
    }
    if (auditValueType === 'TICKET_APPROVAL') {
      if (!auditValueData?.approvals) {
        return null;
      }
      const arr = auditValueData?.approvals || [];
      const approvedCount = arr.filter((item) => item.status === 'Approved')
        .length;
      return (
        <TicketApprovalCard
          client={ticket?.client}
          ticketId={ticket?.ticketId}
          hideMoreInfo
        />
      );
      // return (
      //   <span>
      //     {/* onClick={toggleApprovalDetailsSheetActive}> */} {approvedCount} of{' '}
      //     {auditValueData?.approvals?.length} approved
      //   </span>
      // );
    }
    if (!auditValueType) {
      // GRoup action
      switch (status) {
        case 'PROGRESS':
          return (
            <span>
              {' '}
              <FormattedMessage id="project.task.status.inProgress" />
            </span>
          );
        case 'SUCCESS':
        case 'COMPLETED':
          return (
            <TextStyle variation="subdued" weight="Regular">
              <span> Completed </span>
            </TextStyle>
          );

        default:
          return null;
      }
    }
    return null;
    // <span
    //   onClick={() => {
    //     fetchGetRunbookActionInfo(actionId);
    //   }}
    // >
    //   {' '}
    //   refresh test
    // </span>
  };

  const getContent = (item, isGroupAutoAction = false) => {
    const { name, actionValueType, actionId, actionType } = item.flowAction;
    const parentFlowActionId = item?.parentFlowAction?.actionId;

    const runBookDataProperty = getRunbooksDataProperties(
      actionValueType || actionType,
      isGroupAutoAction
    );
    let actionValueTypeLabel = getTranslatedText(
      intl,
      runBookDataProperty?.i18n || ''
    );

    if (actionValueType === 'CHECKLIST') {
      actionValueTypeLabel = '';
    }

    const flowActionIconName = !actionValueType
      ? 'AutoAction'
      : runBookDataProperty?.icon;

    let isDisabled = false;
    if (parentFlowActionId) {
      isDisabled = !checkActionIdInCompletedItems(parentFlowActionId);
    }
    const isChecked = checkActionIdInCompletedItems(actionId);
    const showTriggerButton =
      !isGroupAutoAction && actionValueType !== 'CHECKLIST';

    const flowActionStatus =
      !isTemplate && getFlowActionStatus(actionId, isGroupAutoAction);

    let disabledMessage = getTranslatedText(
      intl,
      'ticket.runbooks.templateactions.lockedmessage'
    );

    if (actionValueType === 'TICKET_REPLY' && !ticket?.requester) {
      isDisabled = true;
      disabledMessage = getTranslatedText(
        intl,
        'ticket.details.updates.noRequesterMessage'
      );
    } else {
      disabledMessage = getTranslatedText(
        intl,
        'ticket.runbooks.templateactions.lockedmessage'
      );
    }

    return (
      <div>
        {/* {isDisabled ? { content } : content} */}
        <div
          className={`flex center justify-between ${
            isDisabled ? 'disabled opacity5' : ''
          }`}
        >
          <div className="no-scroll flex-shrink-1 mr-5">
            <div className="flex center">
              {!isGroupAutoAction && !isTemplate && (
                <AccessControl
                  roleToCheck={{
                    roles: ['tickets.edit']
                  }}
                  render={
                    <Tooltip
                      title={isDisabled ? disabledMessage : ''}
                      delay={200}
                      duration={250}
                      position="bottom"
                      inertia
                      trigger="mouseenter"
                      animation="shift"
                      animateFill={false}
                      distance={10}
                    >
                      <Checkbox
                        disabled={isDisabled}
                        onChange={(val) => {
                          onActionComplete(val, item);
                        }}
                        name={actionId}
                        id={actionId}
                        checked={isChecked}
                      />
                    </Tooltip>
                  }
                />
              )}
              <div className="mr-10 mt4">
                <div className="ignoreOverride">
                  <SVGIcon name={flowActionIconName} />
                </div>
              </div>
              <div className="grow-1">
                <div className="flex center g10">
                  {actionValueTypeLabel && (
                    <div className="ellipsis">
                      <DisplayText size="large" weight="SemiBold">
                        {actionValueTypeLabel}
                      </DisplayText>
                    </div>
                  )}

                  <Tooltip
                    title={name}
                    delay={200}
                    duration={250}
                    position="top"
                    inertia
                    trigger="mouseenter"
                    animation="shift"
                    animateFill={false}
                    distance={10}
                  >
                    <div className="ellipsis">
                      <DisplayText size="large" weight="Regular">
                        {name}
                      </DisplayText>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
            {!isTemplate && flowActionStatus && (
              <div
                className={`flowActionStatus ${
                  isGroupAutoAction ? ' ml-30' : ' ml-60'
                }`}
              >
                {flowActionStatus}
              </div>
            )}
          </div>

          {showTriggerButton && !isTemplate && (
            <AccessControl
              roleToCheck={{
                roles: ['tickets.edit']
              }}
              render={
                <Tooltip
                  title={
                    isDisabled
                      ? disabledMessage
                      : getTranslatedText(
                          intl,
                          'ticket.runbooks.templateactions.executestep'
                        )
                  }
                  delay={200}
                  duration={250}
                  position="top"
                  inertia
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                  distance={10}
                >
                  <div
                    className={`mb-5 h-20 br50pt ${
                      isDisabled ? 'pointer-events-none' : ''
                    } `}
                    style={{ backgroundColor: 'var(--sops-light-blue)' }}
                    onClick={() => onActionTrigger(item)}
                  >
                    <SVGIcon name="PlayFilled" color="#091ff5" />
                  </div>
                </Tooltip>
              }
            />
          )}
        </div>
        {Array.isArray(item?.flowAction?.groupActions) &&
          item?.flowAction?.groupActions.length > 0 &&
          item.flowAction.groupActions.map((groupAction) => (
            <div className={`ml-50  py-5`}>
              {getContent(groupAction, (isGroupAutoAction = true))}
            </div>
          ))}
      </div>
    );
  };

  const onAction = (action) => {
    console.log('Action selected:', action);
  };

  const calculateProgress = (completed, total) => {
    if (!total) {
      return 0;
    }
    return Math.floor((completed / total) * 100);
  };

  const executeEntityFlowAction = (actionId, actionValueData) => {
    let request = {
      variables: {
        input: {
          entity: 'TICKET',
          entityId: ticket?.ticketId,
          action: {
            flowAction: {
              actionId: actionId
            }
          },
          ...(actionValueData && {
            actionValueData: actionValueData
          })
        }
      }
    };

    executeEntityFlowActionApi(request);
  };

  const addorUpdateTask = (type, task) => {
    const {
      name: title,
      description,
      technician,
      techGroup,
      estimatedTime,
      inlineImages,
      dueDate,
      scheduledStartDate
    } = task;

    const techInput = technician && {
      userId: technician.userId,
      email: technician.email
    };
    const groupInput = techGroup && { groupId: techGroup.groupId };

    const requestVariables = {
      variables: {
        title,
        description,
        technician: techInput,
        techGroup: groupInput,
        estimatedTime,
        inlineImages,
        taskTemplateId: taskTemplate?.taskTemplateId,
        dueDate,
        scheduledStartDate
      },
      input: {
        title,
        description,
        technician: techInput,
        techGroup: groupInput,
        estimatedTime,
        inlineImages,
        taskTemplateId: taskTemplate?.taskTemplateId,
        dueDate,
        scheduledStartDate
      }
    };

    const taskTemplateTemp = {
      ...task,
      taskTemplateId: taskTemplate?.taskTemplateId,
      title: task?.name
    };

    setTaskTemplate(taskTemplateTemp);

    requestVariables.variables.templateId = taskTemplate.taskTemplateId;
    requestVariables.input.templateId = taskTemplate.taskTemplateId;
    executeEntityFlowAction(triggeredAction?.flowAction?.actionId, {
      task: taskTemplateTemp
    });
    return;
  };

  useEffect(() => {
    EventEmitter.subscribe('refetchRunbookActionAudit', (sopId) => {
      const updatedSopId = sopId || ticket?.sop?.sopId;
      if (updatedSopId) {
        setRunbookId(updatedSopId);
        fetchRunbookActionAudit({
          variables: {
            input: {
              ticket: {
                ticketId: ticket?.ticketId
              },
              runbook: {
                sopId: updatedSopId
              }
            }
          }
        });
      }
    });
    return function cleanup() {
      EventEmitter.unsubscribe('refetchRunbookActionAudit');
    };
  }, [ticket]);

  useEffect(() => {
    if (isTemplate) {
      if (props?.runbookId) {
        fetchRunbook({
          variables: {
            input: {
              sopId: props?.runbookId
            }
          }
        });
      }
    } else if (ticket?.sop) {
      fetchRunbookActionAudit();
    }
  }, [props?.runbookId]);

  const getModalTitle = (triggeredAction) => {
    if (triggeredAction?.flowAction?.actionType === 'GROUP') {
      return getTranslatedText(
        intl,
        'admin.runbooks.templateactions.autoaction'
      );
    }
    switch (triggeredAction?.flowAction?.actionValueType) {
      case 'NON_MONITORING_ASSET':
        return 'IT Documentation - ' + triggeredAction?.flowAction?.name;

      case 'default':
        return undefined;
    }
  };

  if (!currentRunBookDetails) {
    return (
      !ticket?.sop && (
        <AccessControl
          roleToCheck={{
            roles: ['tickets.edit']
          }}
          render={ticket?.ticketId && props?.renderEmptyState}
          fallback={<></>}
        />
      )
    );
  }

  return (
    <TimerPopup refFromProps={timerPopupRef}>
      <div
        className={`UnifiedRunbookList position-relative ${
          runbookActionAuditLoading ? 'opacity-half disable-actions' : ''
        }`}
      >
        {!isTemplate && (
          <>
            <div className="p10 pb-0">
              <div className="flex center bg-lvmist p10 ">
                <div className="mr-10">
                  <EmojiRender
                    emoji={currentRunBookDetails?.displayIcon}
                    size="sm"
                  />
                </div>
                <DisplayText size="large" weight="SemiBold">
                  {currentRunBookDetails?.name}
                </DisplayText>
              </div>
            </div>
            {completedListItems?.length > 0 && (
              <>
                <div
                  className={`p15 flex center ptr ${
                    completedItemsOpen ? 'pb-0' : ''
                  }`}
                  onClick={() => setCompletedItemsOpen(!completedItemsOpen)}
                >
                  <div className="min-width-130 flex center mr-5 nowrap">
                    <span className="bg-lvmist br50pt center flex h-20 jspard mr-5 w-20">
                      <SVGIcon
                        name={completedItemsOpen ? 'ArrowDown' : 'ArrowRight'}
                        size="sm"
                      />
                    </span>
                    <DisplayText size="medium" weight="Medium">
                      {completedListItems?.length} of{' '}
                      {currentRunBookDetails?.actions?.length} completed
                    </DisplayText>
                  </div>

                  <ProgressBar
                    progress={calculateProgress(
                      completedListItems?.length,
                      currentRunBookDetails?.actions?.length
                    )}
                    color="primary"
                    size="small"
                  />
                </div>
                <Collapse isOpened={completedItemsOpen}>
                  <div>
                    <ActionList
                      actionRole="menuitem"
                      items={completedListItems.map((listitem) => ({
                        content: getContent(listitem),
                        onAction: () => {
                          onAction(listitem);
                        }
                      }))}
                    />
                  </div>
                </Collapse>
                {!isTemplate && <div className="border-bottom"></div>}
              </>
            )}
          </>
        )}

        {sortedNodes?.length > 0 && (
          <ActionList
            actionRole="menuitem"
            items={sortedNodes.map((listitem) => ({
              content: getContent(listitem),
              onAction: () => {
                onAction(listitem);
              }
            }))}
          />
        )}

        <CustomModal
          large
          open={modalState.isOpen}
          onClose={() => handleModalClose()}
          showCloseButton={false}
          zIndex={517}
          noScroll
        >
          {modalState.type === 'TASK_TEMPLATE' && !taskTemplate?.title ? (
            <Loader />
          ) : (
            modalState.type === 'TASK_TEMPLATE' &&
            taskTemplate?.title && (
              <TaskFromRevamp
                meta={{
                  title: taskTemplate?.title
                    ? getTranslatedText(intl, 'admin.runbooks.tasks.editTask')
                    : getTranslatedText(intl, 'admin.runbooks.tasks.newTask')
                }}
                toggleSheetActive={() => {
                  handleModalClose();
                }}
                type="update"
                hideDelete
                data={taskTemplate}
                addOrUpdateTechGroup={addorUpdateTask}
                readOnly={false}
                isRunbookTemplate
                handleNodeDelete={() => {
                  // handleNodeDelete();
                }}
              />
            )
          )}

          {modalState.type === 'TICKET_UPDATE' && (
            <UpdatePropertyContent
              action={triggeredAction}
              executeEntityFlowAction={executeEntityFlowAction}
              handleModalClose={handleModalClose}
            />
          )}

          {modalState.type === 'TICKET_REPLY' && <Loader />}
        </CustomModal>

        <Modal
          variant={
            triggeredAction?.flowAction?.actionType === 'GROUP'
              ? 'info'
              : 'primary'
          }
          title={getModalTitle(triggeredAction)}
          noScroll
          open={modalOpen}
          showCloseButton={
            triggeredAction?.flowAction?.actionValueType ===
            'NON_MONITORING_ASSET'
          }
          onClose={toggleModal}
          large
        >
          <>
            {triggeredAction?.flowAction?.actionValueType ===
              'NON_MONITORING_ASSET' && (
              <NonMonitoredAssetDetails
                // clientPortalMatch={clientPortalProps}
                // isClientPortal
                assetId={
                  triggeredAction?.flowAction?.actionValueData?.asset?.assetId
                }
                classId={
                  triggeredAction?.flowAction?.actionValueData?.asset
                    ?.assetClass?.classId
                }
                entityName={
                  triggeredAction?.flowAction?.actionValueData?.asset
                    ?.assetClass?.entityName
                }
                isRunbookAction
              />
            )}

            {triggeredAction?.flowAction?.actionValueType === 'SCRIPT' && (
              <RunScriptsModalContent
                ticket={ticket}
                action={triggeredAction}
                toggleModal={toggleModal}
                executeEntityFlowAction={executeEntityFlowAction}
              />
            )}

            {triggeredAction?.flowAction?.actionType === 'GROUP' && (
              <div className="min-height-100">
                <div className="my20">
                  <TextStyle>
                    <FormattedMessage id="ticket.runbooks.templateactions.autoactionmessage" />
                  </TextStyle>
                </div>
                <div className="mt10 flex jend">
                  <ButtonGroup spacing="loose">
                    <Button plainSecondary onClick={toggleModal}>
                      <FormattedMessage id="common.cancel" />
                    </Button>

                    <Button
                      primary
                      loading={executeLoading}
                      onClick={() => {
                        executeEntityFlowAction(
                          triggeredAction?.flowAction?.actionId
                        );
                      }}
                    >
                      <FormattedMessage id="project.details.actions.confirm" />
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            )}
          </>
        </Modal>
        <Sheet open={showKb?.isOpen} onClose={toggleKBSheetActive}>
          <div className="w700 bg-white full-height p2040 flex fcol g20">
            <ArticleReader
              selectedArticle={{ id: showKb?.articleId }}
              closeSheet={toggleKBSheetActive}
              hide={{
                back: true,
                insert: true
              }}
              hideDraft
            />
          </div>
        </Sheet>
        <RunScriptsOutput
          toggleRunScriptsOutputModalActive={toggleRunScriptsOutputModalActive}
          runScriptsOutputModalActive={runScriptsOutputModalActive}
          fetchGetRunbookActionInfo={fetchGetRunbookActionInfo}
        />

        {triggeredAction?.flowAction?.actionValueType === 'TICKET_APPROVAL' && (
          <ApprovalContent
            sheetActive={sheetActive}
            onSheetClose={() => {
              setSheetActive(false);
            }}
            action={triggeredAction}
            executeEntityFlowAction={executeEntityFlowAction}
            toggleSheetActive={() => {
              setSheetActive(false);
            }}
            ticket={ticket}
            runbookId={runbookId}
            executeLoading={executeLoading}
          />
        )}
      </div>
    </TimerPopup>
  );
}
export default withErrorBoundary(injectIntl(UnifiedRunbookList));
